/// <reference types="vite/client" />
import { Link2 } from "lucide-react";

const ADP_PORTAL_URL = (import.meta.env["VITE_ADP_PORTAL_URL"] as string | undefined) ?? "https://my.adp.com";

export function ManagedInADP({ module }: { module: string }) {
  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      minHeight: "60vh", padding: "48px 24px", textAlign: "center",
    }}>
      <div style={{ marginBottom: 16, color: "var(--color-surface-400)" }}><Link2 size={48} /></div>
      <h2 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 8px", color: "var(--color-surface-900)" }}>
        {module} is managed in ADP
      </h2>
      <p style={{ fontSize: 14, color: "var(--color-surface-500)", margin: "0 0 24px", maxWidth: 400 }}>
        Your {module.toLowerCase()} is handled through ADP. Log in to the ADP portal to view or make changes.
      </p>
      <a
        href={ADP_PORTAL_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          padding: "10px 20px", borderRadius: "var(--radius-md)",
          background: "var(--color-brand-600)", color: "#fff",
          fontSize: 13, fontWeight: 600, textDecoration: "none",
        }}
      >
        Open ADP Portal →
      </a>
    </div>
  );
}
